import type { BaseController } from '@infra/controllers/base.controller';
import type { HangupTransferCallUsecase } from './hangup-transfer-call.usecase';

export type HangupTransferCallInput = void;

export type HangupTransferCallOutput = void;

export class HangupTransferCallController
  implements BaseController<HangupTransferCallInput, HangupTransferCallOutput>
{
  constructor(private usecase: HangupTransferCallUsecase) {}

  async handle(): Promise<HangupTransferCallOutput> {
    await this.usecase.run();
  }
}
